<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platid"
              filterable
              clearable
              placeholder="筛选 所属分组"
              @on-change="updatePlatId"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              clearable
              placeholder="筛选代理"
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">筛选游戏:</span>
            <Select
              v-model="table.params.gid"
              filterable
              clearable
              placeholder="下拉筛选游戏"
              @on-change="updategid"
            >
              <Option
                v-for="(item, index) in select.game_list"
                :value="item.game_id"
                :label="item.game_name"
                :key="index"
                >{{ item.game_name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">筛选房间:</span>
            <Select
              v-model="table.params.level"
              filterable
              clearable
              placeholder="下拉筛选房间"
              :disabled="!table.params.gid"
              @on-change="updatelevel"
            >
              <Option
                v-for="(item, index) in select.room_list"
                :value="item.level"
                :label="item.name"
                :key="index"
                >{{ item.name }}
                <span style="color: #bbb"
                  >({{ item.rule }}-{{ item.level }})</span
                ></Option
              >
            </Select>
          </label>
        </Col>
        <Col span="7">
<!--          <Button-->
<!--            type="primary"-->
<!--            @click.native="getList(1)"-->
<!--            :loading="loading"-->
<!--            :disabled="!table.params.platid"-->
<!--            >查询</Button-->
<!--          >-->
          <Button
            type="primary"
            @click.native="getList(1)"
            :loading="loading"
          >查询</Button
          >
          <Button
            type="primary"
            style="margin-left: 10px"
            @click="OpenModal(0, {})"
            >新增游戏风控</Button
          >
          <Button type="info" style="margin-left: 10px" @click="Refres()"
            >同步配置</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="450"
    ></Table>
    <Page
      v-show="table.data.length"
      show-sizer
      show-total
      style="margin-top: 10px"
      :total="table.total"
      :current="table.params.page"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.page_size"
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <Modal v-model="riskConf.show" width="600">
      <p slot="header">
        <span>风控配置</span>
      </p>
      <div>
        <Form
          :ref="riskConf.ref"
          :model="riskConf.params"
          :rules="riskConf.rules"
          :label-width="120"
        >
          <FormItem label="状态">
            <RadioGroup v-model="riskConf.params.status">
              <Radio :label="1">启用</Radio>
              <Radio :label="0">禁用</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem style="text-align: right" label="选择盘口">
            <Row :gutter="8">
              <Col span="11">
                <Select
                  v-model="riskConf.params.platid"
                  filterable
                  placeholder="筛选所属平台"
                  clearable
                >
                  <Option
                    v-for="(item, index) in plat_list"
                    :value="item.id"
                    :label="item.name"
                    :key="index"
                  >
                    {{ item.name
                    }}<span style="color: #bbb">({{ item.id }})</span>
                  </Option>
                </Select>
              </Col>
              <Col span="11">
                <Select
                  v-model="riskConf.params.app_id"
                  filterable
                  placeholder="选择所属盘口"
                  clearable
                  :disabled="!riskConf.params.platid"
                >
                  <Option
                    v-for="(item, index) in app_list.filter(
                      item => item.platform == riskConf.params.platid
                    )"
                    :value="item.appid"
                    :label="item.appName"
                    :key="index"
                  >
                    {{ item.appName }}
                    <span style="color: #bbb">({{ item.appid }})</span>
                  </Option>
                </Select>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="选择子游戏">
            <Row :gutter="8">
              <Col span="11">
                <Select
                  v-model="riskConf.params.gid"
                  filterable
                  clearable
                  placeholder="下拉筛选游戏"
                  @on-change="riskConflevel"
                >
                  <Option
                    v-for="(item, index) in select.game_list"
                    :value="item.game_id"
                    :label="item.game_name"
                    :key="index"
                    >{{ item.game_name }}</Option
                  >
                </Select>
              </Col>
              <Col span="11">
                <Select
                  v-model="riskConf.params.level"
                  filterable
                  clearable
                  placeholder="选择子游戏房间"
                  :disabled="!riskConf.params.gid"
                  @on-change="updaterisklevel"
                >
                  <Option
                    v-for="(item, index) in select.app_room_list.filter(
                      item => item.game_id == riskConf.params.gid
                    )"
                    :value="item.level"
                    :label="item.name"
                    :key="index"
                    >{{ item.name }}
                    <span style="color: #bbb"
                      >({{ item.rule }}-{{ item.level }})</span
                    ></Option
                  >
                </Select>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="最大连续开奖次数">
            <Col span="14">
              <InputNumber
                v-model="riskConf.params.max_count"
                style="width: 100%"
              />
            </Col>
          </FormItem>
          <FormItem label="开奖后触发概率">
            <Col span="24">
              <InputNumber
                v-model="riskConf.params.rate"
                style="width: 58.33%"
              />
              ‱
              <div>每次自然开奖后，根据配置判断下一局是否触发长龙风控</div>
            </Col>
          </FormItem>
          <!-- <FormItem label="今日触发次数">
                        <Col span="14">
                            <InputNumber v-model="riskConf.params.exec" style="width:100%;" />
                        </Col>
                    </FormItem> -->
          <Card dis-hover style="margin-top: 12px">
            <Row style="padding-bottom: 10px">
              <Col>
                <Button type="default">斩断权重配置</Button>
              </Col>
            </Row>
            <Row v-for="(item, index) in riskConf.params.clip_cfg" :key="index">
              <FormItem :label="`斩断${index + 1}`">
                <Col span="11" style="margin-right: 10px">
                  <InputNumber
                    :min="0"
                    :max="100"
                    v-model="riskConf.params.clip_cfg[index].rate"
                    style="width: 100%"
                  />
                </Col>
                <!-- <Col span="2">%</Col> -->
                <Col span="3">
                  <Button type="error" @click="delete_risk_ret(index)"
                    >删除</Button
                  >
                </Col>
              </FormItem>
            </Row>
            <Row style="padding-top: 10px; text-align: center">
              <Col>
                <Button type="primary" @click="addRet">添加斩断权重</Button>
              </Col>
            </Row>
          </Card>
          <!-- <Table border :columns="riskConf.columns" :data="riskConf.params.clip_cfg" style="margin-top: 12px;"></Table> -->
        </Form>
      </div>
      <div slot="footer">
        <Button type="warning" @click="closeRiskConf">取消</Button>
        <Button type="primary" @click="updateConf">保存配置</Button>
      </div>
    </Modal>
    <Modal v-model="riskConfDetail.show">
      <p slot="header">斩断权重</p>
      <Table
        border
        :columns="riskConfDetail.columns"
        :data="riskConfDetail.data"
        style="margin-top: 12px; overflow-x: hidden"
      ></Table>
      <div slot="footer">
        <Button type="primary" @click="riskConfDetail.show = false"
          >关闭</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetAllGameList,
  GetGameRoomInfo,
  GetDoubleRiskList,
  UpdateDoubleRiskList,
  RefreshConfig
} from '@/api/admin/risk'
export default {
  name: 'LotteryAutoRiskCtrl',
  data() {
    return {
      select: {
        game_list: [], //游戏列表
        room_list: [],
        app_room_list: []
      },
      riskConfDetail: {
        show: false,
        data: [],
        columns: [
          {
            key: 'clip',
            title: '斩断',
            align: 'center',
            render: (h, params) => h('span', '斩' + params.row.clip)
          },
          {
            key: 'rate',
            title: '权重',
            align: 'center',
            render: (h, params) => h('span', params.row.rate)
          }
        ]
      },
      riskConf: {
        show: false,
        params: {
          id: '',
          risk_id: 0,
          platid: 0,
          app_id: 0,
          gid: 0,
          rule: '',
          level: '',
          status: 1,
          max_count: 0,
          rate: 0,
          exec: 0,
          clip_cfg: [],
          type: 0
        },
        ref: 'riskConfRef',
        rules: {},
        columns: [
          {
            title: '斩断',
            align: 'center',
            key: 'key'
          },
          {
            key: 'point',
            align: 'center',
            title: '权重',
            render: (h, params) => {
              return h('InputNumber', {
                props: {
                  value: this.riskConf.params.clip_cfg[params.index]['rate']
                },
                on: {
                  'on-change': v => {
                    if (v == null || v < 0) {
                      this.riskConf.params.clip_cfg[params.index]['rate'] = 0
                    } else {
                      this.riskConf.params.clip_cfg[params.index]['rate'] = v
                    }
                  }
                }
              })
            }
          },
          {
            key: 'hit',
            align: 'center',
            title: '操作',
            render: (h, params) =>
              h('span', [h('Button', { prop: { type: 'failed' } }, '删除')])
          }
        ],
        showclip_cfg: false
      },
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      table: {
        params: {
          platid: 0, //所选择分组
          app_id: 0,
          level: '',
          rule: '',
          gid: 0, //所选择得游戏
          page: 1,
          page_size: 10,
          status: -1
        },
        total: 0,
        pagesizes: [10, 20, 30, 40],
        data: [],
        columns: [
          {
            key: 'id',
            align: 'center',
            minWidth: 80,
            renderHeader: (h, params) =>
              this.renderHeader(h, '策略ID', '显示策略ID')
          },
          {
            key: 'app_name',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              let arr = []
              let app_info = this.getPlatInfo(params.row) || {}
              if (app_info) {
                arr.push(
                  h('span', app_info.name),
                  h('span', { style: 'color:#bbb' }, `（${app_info.id}）`)
                )
              } else {
                arr.push(
                  h('span', { style: 'color:#ed4014' }, `未找到指定平台`)
                )
              }
              return h('div', arr)
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '所属平台', '显示所属平台')
          },
          {
            key: 'app_name',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              let app_info = this.getAppInfo(params.row)
              return h('div', [
                h('span', app_info.appName || ''),
                h(
                  'span',
                  { style: 'color:#bbb;' },
                  app_info.appName ? `（${app_info.appid}）` : ''
                )
              ])
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '所属盘口', '显示盘口APP名称')
          },
          {
            key: 'gid',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              let arr =
                this.select.game_list.find(
                  el => el.game_id == params.row.gid
                ) || []
              return h('div', [
                h('span', arr['game_name'] || ''),
                h(
                  'span',
                  { style: 'color:#bbb;' },
                  arr['game_name'] ? `（${arr['game_id']}）` : ''
                )
              ])
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '游戏', '显示游戏名称')
          },
          {
            key: 'nick_name',
            align: 'center',
            minWidth: 65,
            render: (h, params) => {
              let arr =
                this.select.app_room_list.filter(
                  el => el.game_id == params.row.gid
                ) || []
              let arrGame = arr.find(el => el.level == params.row.level) || {}
              return h('div', [
                h('span', arrGame['name'] || ''),
                h(
                  'span',
                  { style: 'color:#bbb;' },
                  arrGame['level']
                    ? `（${arrGame['level']}-${arrGame['rule']}）`
                    : ''
                )
              ])
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '房间', '显示房间名称')
          },
          {
            key: 'rate',
            align: 'center',
            minWidth: 65,
            renderHeader: (h, params) =>
              this.renderHeader(h, '开奖后触发概率', '显示开奖后触发概率'),
            render: (h, params) => h('span', (params.row.rate || 0) + '‱')
          },
          {
            key: 'bet',
            align: 'center',
            minWidth: 65,
            renderHeader: (h, params) =>
              this.renderHeader(h, '斩断权重', '显示斩断权重'),
            render: (h, params) => {
              return h(
                'span',
                {
                  style: {
                    color: '#2d8cf0',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row)
                    }
                  }
                },
                '查看详情'
              )
            }
          },
          {
            key: 'rule',
            align: 'center',
            minWidth: 65,
            renderHeader: (h, params) =>
              this.renderHeader(h, '风控状态', '显示风控状态'),
            render: (h, params) =>
              h(
                'span',
                {
                  style: { color: params.row.status == 1 ? '#32CD32' : 'red' }
                },
                params.row.status == 1 ? '启用' : '禁用'
              )
          },
          {
            key: 'max_count',
            align: 'center',
            minWidth: 65,
            renderHeader: (h, params) =>
              this.renderHeader(h, '最多连续开奖次数', '显示最多连续开奖次数')
          },
          // {
          //     key: "exec",
          //     align: "center",
          //     minWidth: 65,
          //     renderHeader: (h, params) => {
          //         return (this).renderHeader(
          //             h,
          //             "今日触发次数",
          //             "显示今日触发次数"
          //         );
          //     },
          // },
          {
            key: 'hit',
            align: 'center',
            minWidth: 120,
            renderHeader: (h, params) =>
              this.renderHeader(h, '管理', '管理功能'),
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px', padding: '5px 20px' },
                    on: {
                      click: () => {
                        this.OpenModal(1, this.copyData(params.row))
                      }
                    }
                  },
                  '编辑配置'
                ),
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    style: { margin: '2px', padding: '5px 20px' },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          content: '确认删除此条记录',
                          onOk: () => {
                            let param = { type: 2, id: params.row.id }
                            UpdateDoubleRiskList(param).then(res => {
                              this.getList()
                            })
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      },
      ChannelMoney_Modal: { show: false, data: {}, type: 0 }
    }
  },
  methods: {
    showDetail(params) {
      this.riskConfDetail.show = true
      this.riskConfDetail.data = params.clip_cfg || []
    },
    GetAllGameList() {
      return new Promise((resolve, reject) => {
        GetAllGameList({
          gtype: 0,
          page: 1,
          page_size: 10000
        }).then(res => {
          this.select.game_list = res._param.data || []
          resolve()
        })
      })
    },
    GetGameRoomList() {
      let params = { gtype: 0 }
      GetGameRoomInfo(params).then(res => {
        this.select.app_room_list = res._param.data || []
      })
    },
    updatePlatId() {
      this.table.params.app_id = this.app_list.filter(
        el => el.platform == this.table.params.platid
      )[0].appid
    },
    updatelevel(data) {
      if (data) {
        this.table.params.rule =
          this.select.room_list.filter(el => el.level == data)[0]['rule'] || ''
      }
    },
    updaterisklevel(data) {
      if (data) {
        let arr =
          this.select.app_room_list.filter(
            el => el.game_id == this.riskConf.params.gid
          ) || []
        this.riskConf.params.rule =
          arr.filter(el => el.level == data)[0]['rule'] || ''
      }
    },
    riskConflevel(data) {
      this.riskConf.params.level = ''
      this.riskConf.params.rule = ''
    },
    updategid(gid) {
      this.select.room_list =
        this.select.app_room_list.filter(el => el.game_id == gid) || []
      this.table.params.level = ''
      this.table.params.rule = ''
    },
    //获取数据
    getList(num) {
      if (num) {
        this.table.params.page = 1
      }
      let params = {
        ...this.table.params,
        app_id: !this.table.params.app_id ? -1 : this.table.params.app_id
      }
      GetDoubleRiskList(params).then(res => {
        this.table.data = res._param.list || []
        this.table.total = res._param.total || 0
      })
    },
    //查询分条
    limitchange(limit) {
      this.table.params.page = 1
      this.table.params.page_size = limit
      this.getList()
    },
    //查询分页
    pagechange(page) {
      this.table.params.page = page
      this.getList()
    },
    showRIskConf() {
      this.riskConf.show = true
    },
    updateConf() {
      let params = this.riskConf.params
      params.clip_cfg.forEach((item, index) => {
        item.clip = index + 1
      })
      UpdateDoubleRiskList(params).then(res => {
        this.getList()
        this.closeRiskConf()
      })
    },
    closeRiskConf() {
      this.riskConf.show = false
    },
    // 编辑,新增
    OpenModal(type, row = {}) {
      this.riskConf.params = {
        id: '',
        risk_id: 0,
        platid: 0,
        app_id: 0,
        gid: 0,
        rule: '',
        level: '',
        status: 1,
        max_count: 0,
        rate: 0,
        exec: 0,
        clip_cfg: [],
        ...row,
        type: type
      }
      this.riskConf.show = true
    },
    addRet() {
      let obj = { clip: this.riskConf.params.clip_cfg.length + 1, rate: 0 }
      this.riskConf.params.clip_cfg.push(obj)
    },
    delete_risk_ret(id) {
      this.riskConf.params.clip_cfg.splice(id, 1)
      this.riskConf.params.clip_cfg.forEach((item, index) => {
        if (index >= id) {
          item.clip--
        }
      })
    },
    getAppInfo(item) {
      return this.app_list.find(el => el.appid == item.app_id) || {}
    },
    getPlatInfo(item) {
      return this.plat_list.find(el => el.id == item.platid) || {}
    },

    Refres() {
      let param = { is_all: 1, refresh_cfg: [8] }
      RefreshConfig(param).then(res => {
        this.$Notice.success({
          title: '操作提示',
          desc: '成功刷新配置'
        })
      })
    }
  },

  created() {
    this.GetAllGameList()
    this.GetGameRoomList()
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
